import { RootState } from 'types';

export const businessDetailSelector = (state: RootState) => state.businessDetail;
